import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website design services in Ludhiana?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide custom website design and development services for businesses, professionals, and startups in Ludhiana."
      }
    },
    {
      "@type": "Question",
      "name": "What is the starting price for a website in Ludhiana?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our basic website packages start at ₹10,000. Pricing depends on features, number of pages, and overall complexity."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all websites we build are mobile responsive, ensuring a great user experience across smartphones, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build SEO-friendly websites?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our websites are optimized for search engines with clean code, fast loading speed, meta tags, schema, and responsive design."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we build websites using CMS platforms like WordPress, which allow you to update and manage content easily without coding."
      }
    },
    {
      "@type": "Question",
      "name": "Do you create eCommerce websites in Ludhiana?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. We design fully functional eCommerce websites with product management, payment gateways, and secure checkout systems."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Typically, simple websites take 5–7 days, while more complex or eCommerce projects may require 2–4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you assist with domain and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help you choose and set up your domain name, web hosting, SSL certificate, and professional business email accounts."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide ongoing website maintenance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer monthly and yearly website maintenance plans that include updates, backups, security monitoring, and content support."
      }
    },
    {
      "@type": "Question",
      "name": "How do I start a website project in Ludhiana?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can reach out through our contact form or phone number. We'll understand your goals and start the project immediately."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Ludhiana</title>
<meta name="description" content="Top website designer in Ludhiana. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website development company in ludhiana, website designer in ludhiana, website developer in ludhiana, website maker in ludhiana, web developer in ludhiana, web design in ludhiana, web design company in ludhiana, website design company in ludhiana, best web development company in ludhiana, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Ludhiana" />
<meta property="og:description" content="Top Website Designer In Ludhiana. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Ludhiana" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-ludhiana"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Ludhiana" />
<meta name="twitter:description" content="Top website designer in Ludhiana. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-ludhiana" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Ludhiana</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Ludhiana</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Are you looking for a talented and experienced website designer in Ludhiana? You’ve come to the right place! I’m Pankaj, a dedicated website designer focused on creating stunning, user-friendly websites that help you make a lasting impression online and grow your business.
<h3>Why Choose Pankaj for Your Website Design?</h3>
<ol>
  <li><strong>Customized Designs That Reflect Your Brand</strong>
With years of expertise in website design, I specialize in crafting tailored solutions that embody your brand’s unique identity. Whether you require an engaging corporate site, a robust e-commerce platform, or a personal blog, I ensure your website not only captivates your audience but also serves its purpose effectively.</li>
  <li><strong>SEO-Friendly Websites for Enhanced Visibility</strong>
A beautiful website is only effective if it can be found. My designs include essential SEO practices, helping your site rank higher on search engines like Google, which increases your visibility and attracts more potential customers.</li>
  <li><strong>Comprehensive Website Design Services</strong>
I offer a full suite of services, including website development, redesigns, e-commerce solutions, and ongoing maintenance. My proficiency with popular CMS platforms, such as WordPress, empowers you to easily manage your content once your site is launched.</li>
  <li><strong>Transparent Pricing and Exceptional Support</strong>
I believe in clear communication and providing transparent pricing. After discussing your project requirements, I will provide a detailed quote so you know what to expect. My commitment to client satisfaction means I’m here to support you even after your website goes live.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique, modern designs that align with your brand identity, enhancing user engagement and ensuring a positive user experience.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce platforms designed to optimize conversions and provide a seamless shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professionally designed websites that effectively showcase your business or personal projects, engaging visitors and conveying your goals clearly.</li>
  <li><strong>SEO and Digital Marketing Services</strong>
Basic SEO practices included in all designs, with options for advanced strategies through collaboration with trusted marketing partners.</li>
</ul>
<h3>Get Started Today</h3>
Ready to take your online presence to the next level? Contact me today to discuss your vision, and let’s work together to create a website that truly represents your brand in the digital landscape.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites can Pankaj design in Ludhiana?</h4>
<p>Pankaj specializes in designing a variety of websites, including corporate sites, e-commerce platforms, personal blogs, and portfolios. Each website is tailored to meet the specific needs and goals of the client.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj offers high-quality, responsive, and SEO-friendly websites crafted with attention to detail. His extensive experience ensures that each project effectively communicates your brand identity while providing a seamless user experience.</p>

<h4>Does Pankaj provide SEO services for my website?</h4>
<p>Yes, Pankaj incorporates basic SEO practices in all his website designs to enhance visibility on search engines. For more advanced SEO strategies, he can collaborate with trusted partners who specialize in digital marketing.</p>

<h4>How much does it cost to design a website with Pankaj?</h4>
<p>The cost of designing a website depends on several factors, including the project's complexity, the number of pages, and any additional features you may want. Pankaj provides project-specific quotes after discussing your requirements and budget.</p>

<h4>Can I update my website content after it’s launched?</h4>
<p>Absolutely! Pankaj builds websites using user-friendly CMS platforms like WordPress, allowing you to easily manage and update your content once the site is live. He also provides training and documentation to help you navigate updates.</p>

<h4>What if I need help with my website after it’s live?</h4>
<p>Pankaj offers ongoing maintenance and support for all his clients. This includes troubleshooting, updates, and performance improvements to ensure your website remains secure and effective over time.</p>

<h4>How long does it take to complete a website design project?</h4>
<p>The timeline for completing a website design project varies based on its complexity and specific requirements. After discussing your project, Pankaj will provide a realistic timeline, which typically ranges from a few weeks to a couple of months.</p>

<h4>How can I get in touch with Pankaj for my website design project?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He will be happy to discuss your project and help you create a website that meets your needs.</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
